import React from 'react';
import './account.scss';

import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import Cookies from 'js-cookie';

import Download from '../../util/download';
import { getLogsFlag, setLogsFlag, fireAnalytics } from '../../pages/utils';

// Actions
import { deleteDevice } from '../../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../../store/actions/playlistActions';
import { clearUser } from '../../store/actions/userActions';
import { clearSubscription } from '../../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER, DOWN, UP } from '../../util/remoteButtons';
import { DownloadEnum } from '../../util/playerEnum';
import { withNavigate } from '../../util/withNavigate';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: getLogsFlag(),
      logsTextVisibilty: false,
      clearCache: false,
      selectedBtn: 'close',
      artworks: props.artworks,
      currentDownloads: props.currentDownloads,
      freeInternal: 0,
      usedInternal: 0,
      freeExternal: 0,
      usedExternal: 0,
      styles: this.getStyles()
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'close';
    this.enableLogs = 0;
    this.logsTimeout = null;
    this.logsText = '';
    this.download = new Download();
    this.acc = React.createRef();
  }
  componentDidMount() {
    fireAnalytics('Page', 'Account Page Loaded');
    console.log(this.props.subscription)
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    setTimeout(() => {
      this.acc.current && this.acc.current.focus();
    }, 300);

    this.download.checkFreeSpace((key) => {
      console.log('Check Free Space');
      if(key === "Check Successful"){
        this.setState({
          freeInternal: this.download.appSpace.freeInternal,
          usedInternal: this.download.appSpace.usedInternal,
          freeExternal: this.download.appSpace.freeExternal,
          usedExternal: this.download.appSpace.usedExternal,
        })
      }else{

      }
    });
  }

  goToPage = (pageLink) => {
    const { navigate } = this.props;
    navigate(pageLink);
  };

  handleKeyDown(e) {
    e.stopPropagation();
    
    this.handleLogToggleSequence(e);
    
    if (this.state.clearCache) {
      this.handleClearCacheNavigation(e);
    } else {
      this.handleMainMenuNavigation(e);
    }
  }

  handleLogToggleSequence(e) {
    const { which } = e;
    const isUpOrDown = which === 38 || which === 40; 

    if (!isUpOrDown) {
      this.enableLogs = 0;
      return;
    }

    if (this.logsTimeout) {
      clearTimeout(this.logsTimeout);
    }

    if (this.enableLogs === 76 && which !== 40) {
      this.enableLogs = 0;
    }

    this.enableLogs += which;

    // Check for complete sequence (154 = 38 + 38 + 38 + 40)
    if (this.enableLogs === 154) {
      this.toggleLogs();
      this.enableLogs = 0;
    }

    this.logsTimeout = setTimeout(() => {
      this.enableLogs = 0;
    }, 7000);
  }

  toggleLogs() {
    const isLogsEnabled = this.state.logs;
    const message = isLogsEnabled ? 'Player Logs Disabled' : 'Player Logs Enabled';

    setLogsFlag(!isLogsEnabled);
    this.setState({ logs: !isLogsEnabled });

    this.showLogsMessage(message);
  }

  showLogsMessage(message) {
    this.logsText = message;
    this.setState({ logsTextVisibilty: true });
    setTimeout(() => {
      this.setState({ logsTextVisibilty: false });
    }, 3000);
  }

  handleClearCacheNavigation(e) {
    const { which } = e;

    switch (which) {
      case RIGHT:
        this.setState({ selectedBtn: 'Yes' });
        break;
      case LEFT:
        this.setState({ selectedBtn: 'No' });
        break;
      case ENTER:
        this.handleClearCacheAction();
        break;
      case 27: // ESC
      case BACK:
        this.props.onClose();
        break;
    }
  }

  handleClearCacheAction() {
    if (this.state.selectedBtn === 'No') {
      this.setState({ clearCache: false });
      setTimeout(() => {
        this.setState({ selectedBtn: 'clear' });
      }, 200);
    } else if (this.state.selectedBtn === 'Yes') {
      this.executeClearCache();
    }
  }

  executeClearCache() {
    if (this.download?.isDownloadProgress) {
      this.download.cancelDownload((key) => {
        console.log("Cancel Download after clear cache", key);
      });
    }

    this.download.removeAllDownloads((key) => {
      console.log('Remove Cache Callback', key);
      this.deleteCacheCallback(key);
    });
  }

  handleMainMenuNavigation(e) {
    const { which } = e;

    switch (which) {
      case RIGHT:
        this.navigateRight();
        break;
      case LEFT:
        this.navigateLeft();
        break;
      case DOWN:
        this.setState({ selectedBtn: 'reboot' });
        break;
      case UP:
        this.setState({ selectedBtn: 'close' });
        break;
      case ENTER:
        this.handleMainMenuAction();
        break;
      case 27: // ESC
      case BACK:
        this.props.onClose();
        break;
    }
  }

  navigateRight() {
    const { selectedBtn } = this.state;
    const navigationMap = {
      'logout': 'close',
      'close': 'clear',
      'reboot': 'reset'
    };

    const nextBtn = navigationMap[selectedBtn];
    if (nextBtn) {
      this.setState({ selectedBtn: nextBtn });
    }
  }

  navigateLeft() {
    const { selectedBtn } = this.state;
    const navigationMap = {
      'close': 'logout',
      'clear': 'close',
      'reset': 'reboot'
    };

    const nextBtn = navigationMap[selectedBtn];
    if (nextBtn) {
      this.setState({ selectedBtn: nextBtn });
    }
  }

  handleMainMenuAction() {
    const { selectedBtn } = this.state;

    const actions = {
      'close': () => this.props.onClose(),
      'logout': () => this.handleLogout(),
      'clear': () => this.initiateClearCache(),
      'reboot': () => this.download.restartDevice(),
      'reset': () => this.resetId()
    };

    const action = actions[selectedBtn];
    if (action) {
      action();
    }
  }

  handleLogout() {
    const userEmail = this.props.user?.data?.user?.email || '';
    fireAnalytics('User', 'Logged Out', userEmail);
    this.logout();
  }

  initiateClearCache() {
    this.setState({ clearCache: true });
    setTimeout(() => {
      this.setState({ selectedBtn: 'No' });
    }, 200);
  }

  deleteCacheCallback = (key) => {
    switch (key) {
      case DownloadEnum.CACHE_CLEAR_SUCCESS:
        console.log("Cache clear successfully")
        this.setState({ clearCache: false });
        this.goToPage('/');
        break;
      case DownloadEnum.CACHE_CLEAR_ERROR:
        console.log("Cache clear unsuccess. Try Again");
        this.goToPage('/');
        break;
    }
  }

  logout = async () => {
    try {
      const deviceID = this.props.device ? this.props.device.data ? this.props.device.data.id : '' : ''
      const response = await this.props.deleteDevice(deviceID);
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.goToPage('/');
      }
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      localStorage.removeItem('DeviceID');
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.goToPage('/error');
        }, 10);
        return;
      }
    } catch (e) {
      // console.log(e);
    }
  };

  resetId = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      localStorage.removeItem('DeviceID');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.goToPage('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.goToPage('/');
      }
    } catch (e) {
      // console.log(e);
    }
  };

  getStyles = () => {
    const isPortrait = window.innerWidth <= window.innerHeight;
    return {
      accountDiv: isPortrait ? '55%' : '89%',
      footerHeight: isPortrait ? '120px' : '95px',
      footerFontHeight: isPortrait ? '1.8rem' : '1.5rem',
      btnDivHeight: isPortrait ? '3vh' : '6vh'
    };
  };

  handleResize = () => {
    this.setState({ styles: this.getStyles() });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { styles } = this.state;
    return (
      <div
        className="account"
        style={{
          height: styles.accountDiv,
        }}
        ref={this.acc}
        onKeyDown={this.handleKeyDown}
        tabIndex={9}
      >
        {this.state.clearCache ? (
          <div
            id="models"
            className="reg-response-modal"
            onKeyDown={this.handleKeyDown}
            style={{ position: 'relative', zIndex: '9999' }}
          >
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%', fontSize: '2em', padding: '0 1em' }}>
                Do you want to clear device cache and reload app?
              </h2>
              <button
                ref="no"
                id="No"
                className='account__btns__cache'
                style={{
                  float: 'left',
                  marginLeft: '14%',
                  background : this.state.selectedBtn === 'No' ? '#910048' : ''
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                className='account__btns__cache'
                style={{
                  float: 'right',
                  marginRight: '18%',
                  background : this.state.selectedBtn === 'Yes' ? '#910048' : ''
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        <h3 className="account__header">Account</h3>

        <div className="account__info">
          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">User:</div>
            <div className="account__info__wrapper__text2">{this.props.user.data.user ? this.props.user.data.user.email : ''}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Device ID:</div>
            <div className="account__info__wrapper__text2">{this.props.app.SCAPDeviceId}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Device Name:</div>
            <div className="account__info__wrapper__text2">{this.props.device.data.name}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Subscription:</div>
            <div className="account__info__wrapper__text2">{this.props.subscription.data.plan ? this.props.subscription.data.plan.description : ''}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Internal Storage: {this.download.internalPath}</div>
            <div className="account__info__wrapper__text2">free: {this.state.freeInternal}GB  / used: {this.state.usedInternal}GB</div>
            <div className="account__info__wrapper__text3">{this.state.freeInternal < 1 ? "Low Storage" : ""}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">USB Storage: {this.download.isUSB ? this.download.staticInternalPath : 'N/A'}</div>
            <div className="account__info__wrapper__text2">{this.download.isUSB ? `free: ${this.state.freeExternal}GB  / used: ${this.state.usedExternal}GB` : ""}</div>
            <div className="account__info__wrapper__text3">{this.download.isUSB ? this.state.freeExternal < 1 ? "Low Storage" : "" : ""}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Artworks downloaded:</div>
            <div className="account__info__wrapper__text2">{`${this.state.currentDownloads} / ${this.state.artworks.length}`}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Download status:</div>
            <div className="account__info__wrapper__text2">{this.download.artworkName}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Storage in use:</div>
            <div className="account__info__wrapper__text2">{this.download.staticInternalPath === 'file://internal/Blackdove/' ? 'INTERNAL STORAGE' : 'USB STORAGE'}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Media Type:</div>
            <div className="account__info__wrapper__text2">{this.download.quality4k === 'true' && this.download.highQuality === 'true' ? 'UHD' : 'FHD'}</div>
          </div>

          <div className="pair__box__container__qrcode" style={{ position: 'absolute', right: '12%', top: '20%' }}>
            <QRCodeSVG
              value={this.props.app.SCAPDeviceId}
              size={180}
              style={{border: '0.5vh solid white' }}
            />
            <img className="pair__box__container__qrcode__logo" src="assets/img/red-logo.svg" alt="" />
          </div>
        </div>

        <div 
          className="account__btns"
          style={{
            height: styles.btnDivHeight,
          }}
          >
          <button
            tabIndex="7"
            ref="logout"
            style={this.state.selectedBtn === 'logout' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Logout
          </button>
          <button
            tabIndex="6"
            ref="close"
            style={this.state.selectedBtn === 'close' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Close
          </button>
          <button
            tabIndex="6"
            ref="clear"
            style={this.state.selectedBtn === 'clear' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Clear Cache
          </button>
        </div>

        <div 
          className="account__btns_2"
          style={{
            height: styles.btnDivHeight,
          }}
          >
          <button
              ref="reboot"
              style={this.state.selectedBtn === 'reboot' ? { border: '6px solid #910048' } : null}
              className="account__btns__btn"
            >
            Reboot Device
          </button>
          <button
              ref="resetBtn"
              style={this.state.selectedBtn === 'reset' ? { border: '6px solid #910048' } : null}
              className="account__btns__btn"
            >
            Reset Player ID
          </button>
        </div>

        <div
          className="account__footer"
          style={{
            height: styles.footerHeight,
            fontSize: styles.footerFontHeight,
          }}
        >
          For help contact: <strong>support@blackdove.com</strong>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(withNavigate(Account));
